import React, { lazy } from 'react';
import { Route } from 'react-router-dom';

// All admin pages are lazy-loaded — they're only reached by admin users.
const UsersDataTablePage = lazy(() => import('../admin/UsersDataTablePage'));
const DevicesPage = lazy(() => import('../admin/DevicesPage'));
const UsersDevicesPage = lazy(() => import('../admin/UsersDevicesPage'));
const UnmatchedDevicesPage = lazy(() => import('../admin/UnmatchedDevicesPage'));
const MissedInvoicePage = lazy(() => import('../admin/MissedInvoicePage'));
const CachePage = lazy(() => import('../admin/CachePage'));
const ResellerInventoryPage = lazy(() => import('../admin/ResellerInventoryPage'));
const PushNotificationPage = lazy(() => import('../admin/PushNotificationPage'));
const DataPage = lazy(() => import('../admin/DataPage'));
const SettingPage = lazy(() => import('../admin/SettingPage'));
const SummaryPage = lazy(() => import('../admin/SummaryPage'));
const OAuthAppsPage = lazy(() => import('../admin/OAuthAppsPage'));
const OAuthAppPage = lazy(() => import('../admin/OAuthAppPage'));
const OAuthAppDetailPage = lazy(() => import('../admin/OAuthAppDetailPage'));

export const adminRoutes = [
  <Route key="admin-summary" exact path="/admin/summary" component={SummaryPage} />,
  <Route key="admin-users" exact path="/admin/users" component={UsersDataTablePage} />,
  <Route key="admin-devices" exact path="/admin/devices" component={DevicesPage} />,
  <Route key="admin-add-users-devices" exact path="/admin/add-users-devices" component={UsersDevicesPage} />,
  <Route key="admin-unmatched-devices" exact path="/admin/unmatched-devices" component={UnmatchedDevicesPage} />,
  <Route key="admin-missed-invoices" exact path="/admin/missed-invoices" component={MissedInvoicePage} />,
  <Route key="admin-cache" exact path="/admin/cache" component={CachePage} />,
  <Route key="admin-reseller-inventory" exact path="/admin/reseller-inventory" component={ResellerInventoryPage} />,
  <Route key="admin-push-notification" exact path="/admin/push-notification" component={PushNotificationPage} />,
  <Route key="admin-data" exact path="/admin/data/:id?" component={DataPage} />,
  <Route key="admin-setting" exact path="/admin/setting" component={SettingPage} />,
  <Route key="admin-oauth-apps" exact path="/admin/oauth-apps" component={OAuthAppsPage} />,
  <Route key="admin-oauth-apps-new" exact path="/admin/oauth-apps/new" component={OAuthAppPage} />,
  <Route key="admin-oauth-apps-edit" exact path="/admin/oauth-apps/:id" component={OAuthAppPage} />,
  <Route key="admin-oauth-apps-details" exact path="/admin/oauth-apps/:id/details" component={OAuthAppDetailPage} />,
];
